module.exports = __webpack_public_path__ + "/img/Crystal-HC49-Labeled-U0lHrY.svg";